function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.398,23.797c-2.63-2.254-4.133-4.133-4.133-12.023c0-5.029-3.354-7.152-5.789-8.035c0-0.014,0.003-0.027,0.003-0.043  c0-1.66-1.111-3.006-2.48-3.006c-1.369,0-2.479,1.346-2.479,3.006c0,0.016,0.003,0.029,0.004,0.043  c-2.436,0.883-5.79,3.006-5.79,8.035c0,7.891-1.502,9.77-4.133,12.023c-2.63,2.254,0,3.193,1.691,3.193c1.69,0,10.707,0,10.707,0  s9.018,0,10.708,0C28.398,26.99,31.029,26.051,28.398,23.797z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.735,28.42c0.68,1.693,2.329,2.891,4.265,2.891c1.936,0,3.586-1.197,4.266-2.891c-2.333,0-4.266,0-4.266,0  S14.068,28.42,11.735,28.42z"
});

function SvgAlarm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 40",
    enableBackground: "new 0 0 32 32",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.0c7004bc.svg";
export { ForwardRef as ReactComponent };